import { filterObj } from 'ui-lib'

import fetchApi from '../fetch-api'
import * as t from 'io-ts'

export const DashboardCompanySearchIO = t.type({
  companyID: t.string,
  name: t.string,
});

export type DashboardCompanySearch = t.TypeOf<typeof DashboardCompanySearchIO>;

const dashboardCompanySearchQuery = ({
  searchKey,
}: {
  searchKey: string
}) => ({
  queryKey: [
    'search-company',
    filterObj(searchKey, (_, value) => !!value),
  ],
  queryFn: () =>
    fetchApi({
      service: 'core-service',
      pathname: `/search-company?searchQuery=${searchKey}`,
      headers:{method: 'GET'},
      codec: t.array(DashboardCompanySearchIO),
    }),
  keepPreviousData: true,
})

export default dashboardCompanySearchQuery
